import Network from "../networkHandler/Network";
import Auth from "../auth/auth";

export class TranslationService {

  /**
   * Translate a published story to a target language.
   *
   * Calls the ai-service's translate-story endpoint which handles:
   * - Delta detection (only translates new/changed keys)
   * - Batch AI translation
   * - Uploading the language pack to the platform server
   *
   * Idempotent — safe to call even if pack already exists and is up-to-date.
   */
  async translateStory(
    gameId: number,
    targetLanguage: string,
  ): Promise<{ success: boolean; keysTranslated: number; totalKeys: number }> {
    const serverAssistant = Network.withServerAssistant();
    const client = await serverAssistant.getAiClient();
    const token = Auth.getLoginToken() || "";

    const { data, error } = await client.POST("/api/v1/ai/translate-story", {
      body: { gameId, targetLanguage, bearerToken: token },
    });

    if (error) {
      throw new Error("Translation failed");
    }

    return data;
  }
}
